import { Routes } from '@angular/router';
import { NormsLookupComponent } from './norms-lookup/norms-lookup.component';
import { environment } from '../environments/environment';

// Pipe Fabrication is still in development — exposed in dev only. When the flag
// is off, block direct URL access and fall back to the default route.
const pipeFabEnabled = () => !!(environment as { showPipeFab?: boolean }).showPipeFab;

// Soft Crafts (Scaffold / Paint / Insulation) is still in development — dev only.
const softCraftEnabled = () => !!(environment as { showSoftCraft?: boolean }).showSoftCraft;

export const routes: Routes = [
  { path: '', redirectTo: 'norms-lookup', pathMatch: 'full' },
  { path: 'norms-lookup', component: NormsLookupComponent },
  {
    path: 'labor-hours',
    loadComponent: () => import('./labor-hours/labor-hours.component').then(m => m.LaborHoursComponent)
  },
  {
    path: 'pipe-fab',
    canMatch: [pipeFabEnabled],
    loadComponent: () => import('./pipe-fab/pipe-fab.component').then(m => m.PipeFabComponent)
  },
  {
    path: 'soft-craft',
    canMatch: [softCraftEnabled],
    loadComponent: () => import('./soft-craft/soft-craft.component').then(m => m.SoftCraftComponent)
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./dashboard/dashboard.component').then(m => m.DashboardComponent)
  },
  { path: '**', redirectTo: 'norms-lookup' }
];
